import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { cityJobs, cityMax } from "../utils/Data";
import Card from "./Card";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import { client } from "../client";
import Pagination from "./Pagination";
import { NoResults, ResultsLayout, ResultsSkeleton } from "./ResultsState";
import { feature } from "../utils/features";

function JobCardRender(job) {
  return (
    <Card
      key={job._id}
      btnId={job._id}
      title={job.title}
      companyName={job.companyName}
      categories={job.categories}
      city={job.city}
      salary={job.salary}
      postedOn={job.postedOn}
      externalUrl={job.url}
      source={job.source}
      postExpiry={job.postExpiry}
    />
  );
}

function CityJobsResults() {
  const history = useNavigate();
  const { city } = useParams();
  const [jobsArr, setJobsArr] = useState([]);

  const [currentPage, setCurrentPage] = useState(0)
  const [maxOpenings, setMaxOpenings] = useState()
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)

  function activePageinc (){
    if(currentPage < ((maxOpenings/10)-1))
      { setCurrentPage(currentPage+1); window.scrollTo({ top: 0, behavior: "smooth" }); }
  }

  function activePagedec(){

    if(currentPage != 0 ) {
      { setCurrentPage(currentPage-1); window.scrollTo({ top: 0, behavior: "smooth" }); }
    }
    
  }

  useEffect(() => {
    setLoading(true);
    setLoadError(false);
    client
      .fetch(cityJobs(city,currentPage))
      .then((jobs) => {
        setJobsArr(jobs);
      })
      .catch((err) => {
        console.log(err);
        setLoadError(true);
      })
      .finally(() => setLoading(false));

    client.fetch(cityMax(city))
      .then((res)=> {
        setMaxOpenings(res)
      })
  }, [currentPage]);

 
  if (loading) {
    return <ResultsSkeleton />;
  }

  if (loadError || jobsArr.length < 1) {
    return <NoResults error={loadError} message={`No jobs posted in ${city} right now`} />;
  }
  if (feature("modernCards")) {
    return (
      <ResultsLayout
        heading={`Jobs in ${city.trim()}`}
        footer={<Pagination currentPage={currentPage} increment={activePageinc} decrement={activePagedec} maxOpenings={maxOpenings} />}
      >
        {jobsArr.map(JobCardRender)}
      </ResultsLayout>
    );
  }
  return (
    <div className="px-4 mx-4">
      <button onClick={() => history(-1)}>
        <div className="text-lg font-semibold text-gray-900 flex flex-row items-center">
          <ChevronLeftIcon className="text-gray-900 h-5 w-5" />
          <h1>Back</h1>
        </div>
      </button>
        <h1 className="font-bold text-xl text-primary font-[Poppins] mt-8 md:px-16 md:mx-16 px-2 mx-2">Showing Results for {city}</h1>
      <div className="md:px-16 md:mx-16 px-2 mx-2 mt-8 mb-16 ">
          {
             jobsArr.map(JobCardRender)
          }
          
          </div>
          <Pagination
             currentPage={currentPage}
             increment={activePageinc}
             decrement={activePagedec}
             maxOpenings={maxOpenings}
          />
    </div>
  );
}

// Remount when the city changes so page number and results reset together. (UX-008)
function CityJobs() {
  const { city } = useParams();
  return <CityJobsResults key={city} />;
}

export default CityJobs;
